import { useTracking } from '@change-corgi/core-react/tracking';

import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuidesArticle/pageContext';
import type { ArticleContentType } from '#src/app/pages/petitionGuidesArticle/pageContext';

type Result = ModelHookResult<
	{
		articles: ReadonlyArray<Readonly<ArticleContentType>>;
		displayed: boolean;
	},
	{
		trackArticleClick: () => void;
	}
>;

export function useExploreArticlesSection(): Result {
	const {
		data: {
			articles,
			article: { slug },
		},
	} = usePetitionGuidesPageData();

	const track = useTracking();

	const filteredArticles = articles
		// Return all core articles, except for current article
		.filter((article) => article.slug !== slug)
		// Show up to 4 articles
		.slice(0, 4);

	return {
		data: {
			articles: filteredArticles,
			displayed: filteredArticles.length > 0,
		},
		actions: {
			trackArticleClick: () => {
				void track('petition_guides_article_explore_more_sidebar_click');
			},
		},
	};
}
